import React from 'react';
import { Briefcase, Calendar, Award, TrendingUp } from 'lucide-react';
import { useExperience } from '../../../context/ExperienceContext';

const ExperienceStats = ({ experiences, totalExperience }) => {
  const { companiesCount } = useExperience();
  const currentRole = experiences.find(exp => exp.isCurrent);
  const totalAchievements = experiences.reduce((total, exp) => total + (exp.achievements?.length || 0), 0);

  const stats = [
    {
      icon: Calendar,
      label: 'Total Experience',
      value: `${totalExperience.displayText} Years`,
      color: 'text-blue-500',
      bgColor: 'bg-blue-100 dark:bg-blue-900/30'
    },
    {
      icon: Briefcase,
      label: 'Companies',
      value: companiesCount,
      color: 'text-green-500',
      bgColor: 'bg-green-100 dark:bg-green-900/30'
    },
    {
      icon: Award,
      label: 'Key Achievements',
      value: totalAchievements,
      color: 'text-purple-500',
      bgColor: 'bg-purple-100 dark:bg-purple-900/30'
    },
    {
      icon: TrendingUp,
      label: 'Current Role',
      value: currentRole ? currentRole.jobTitle : 'Available',
      color: 'text-orange-500',
      bgColor: 'bg-orange-100 dark:bg-orange-900/30'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-white dark:bg-gray-800 p-6 rounded-lg border border-gray-200 dark:border-gray-700 text-center hover:shadow-lg transition-shadow"
        >
          <div className={`${stat.bgColor} w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4`}>
            <stat.icon className={`w-6 h-6 ${stat.color}`} />
          </div>
          <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
            {stat.value}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-400">
            {stat.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExperienceStats;